import { isInteger } from "lodash"
import moment from "moment"

export function getTimestamp(timestamp) {
  return moment(timestamp).format("YYYY, MMM, DD")
}

export function getTimestampFormated(timestamp) {
  return moment(timestamp).format("YYYY, MMM, DD, h:mm:ss a")
}

export function getDiffDateFromNow(date) {
  return moment(date).fromNow()
}

export function numberIsSame(first, second) {
  if (first === second) {
    return true
  } else {
    return false
  }
}

export function checkForMinusNumber(e) {
  if (Math.sign(e.target.value) === -1) {
    return true
  }
  return false
}

export const removeDocument = setselectedFiles => {
  setselectedFiles({})
}

export const getYears = () => {
  const year = new Date().getFullYear()
  const arr = []
  for (let i = 2020; i <= year; i++) {
    arr.push({ value: i, label: i })
  }
  return arr
}

export const getMonthName = month => {
  return moment()
    .month(month - 1)
    .format("MMMM")
}

export const setToFixed = number => {
  if (!isInteger(number)) {
    return typeof number
  } else {
    return number
  }
}
